// material-ui
import { Typography } from '@mui/material'

// project imports
import { useHasPermission } from '../../../../../app/hooks'
import { MenuItem } from '../../../../../types'
import menuItems from '../../../../menu-items'
import NavGroup from './NavGroup'
import { useGetListOfferToPayQuery } from '../../../../../app/services/offerToPay'
import React, { useMemo } from 'react'

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const { data: dataPending } = useGetListOfferToPayQuery({
    filterType: 'COUNT_PENDING_MY_TURN',
    limit: 1,
    page: 1
  })

  const pendingCount = dataPending?.data?.totalCount || 0

  const items = useMemo((): MenuItem[] => {
    const list = menuItems()
    if (pendingCount > 0) {
      // Tìm item Đề nghị thanh toán để gắn badge
      // manager -> children -> find id: 'finance-dntt-all'
      return list.map((group: MenuItem) => {
        if (group.children) {
          return {
            ...group,
            children: group.children.map((item) => {
              if (item.id === 'finance-dntt-all') {
                return {
                  ...item,
                  chip: {
                    label: pendingCount.toString(),
                    color: 'error' as const,
                    size: 'small' as const,
                    variant: 'filled' as const
                  }
                }
              }
              return item
            })
          }
        }
        return group
      })
    }
    return list
  }, [pendingCount])

  const navItems = items.map((item: MenuItem) => {
    const check = useHasPermission(item?.premissions || [])
    if (check) {
      switch (item?.type) {
        case 'group':
          return <NavGroup key={item?.id} item={item} />
        default:
          return (
            <Typography key={item?.id} variant='h6' color='error' align='center'>
              Menu Items Error
            </Typography>
          )
      }
    }
    return ''
  })

  return <>{navItems}</>
}

export default MenuList
